import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { post } from './client';
import type { PagedResult, PatientListItem } from './model';
import { type PatientListParams, patientKeys } from './patient';

export const myPatientKeys = {
  all: ['my-patient'] as const,
  list: (p: PatientListParams) => [...myPatientKeys.all, 'list', p] as const,
};

// 「我的患者」复用患者列表接口, 仅多带 onlyMine 过滤项
export const listMyPatients = (p: PatientListParams) =>
  post<PagedResult<PatientListItem>>('/patient/list', { ...p, onlyMine: true });

export const addMyPatient = (patientId: string) =>
  post<null>('/patient/my/add', { patientId });

export const removeMyPatient = (patientId: string) =>
  post<null>('/patient/my/remove', { patientId });

export const useMyPatientListQuery = (p: PatientListParams) =>
  useQuery({
    queryKey: myPatientKeys.list(p),
    queryFn: () => listMyPatients(p),
  });

/** 入组/移出我的患者；成功后失效相关列表 query */
export const useMyPatientMutation = () => {
  const qc = useQueryClient();
  return {
    add: useMutation({
      mutationFn: (patientId: string) => addMyPatient(patientId),
      onSuccess: () => {
        qc.invalidateQueries({ queryKey: patientKeys.all });
        qc.invalidateQueries({ queryKey: myPatientKeys.all });
      },
    }),
    remove: useMutation({
      mutationFn: (patientId: string) => removeMyPatient(patientId),
      onSuccess: () => {
        qc.invalidateQueries({ queryKey: patientKeys.all });
        qc.invalidateQueries({ queryKey: myPatientKeys.all });
      },
    }),
  };
};
